import {
  ADD_QUESTION,
  REMOVE_QUESTION,
  UPDATE_QUESTION,
  UPDATE_TEMPLATE,
  DUPLICATE_LAST_QUESTION,
  SET_ACTIVE_QUESTION,
  SET_QUESTION_OPTION_ERRORS,
  ADD_QUESTION_OPTION,
  REMOVE_QUESTION_OPTION,
  UPDATE_QUESTION_OPTION,
  REMOVE_FORM_ERRORS,
  RESET_STATE,
  SWITCH_QUESTION_ORDER,
  CLONE_QUESTION,
  REORDER_QUESTION_OPTIONS
} from '../actions/dataEntryTemplateGeneratorActions';

const initState = {
  title: '',
  yearLevels: [],
  roles: [],
  error: {},
  questions: [
    {
      id: new Date().getTime(),
      type: { value: 'shortanswer' },
      name: 'question1',
      title: '',
      content: '',
      markdown: '',
      order: 1,
      isActive: true,
      required: true,
      options: [],
      variant: null,
      error: {}
    }
  ],
  isEditable: true
};

const templateGeneratorReducer = (state = initState, action) => {
  let newState = { ...state };

  switch (action.type) {
    case RESET_STATE:
      newState = { ...initState };
      break;

    case ADD_QUESTION:
      newState.questions = newState.questions.map((question) => {
        return { ...question, isActive: false };
      });

      newState.questions = [...newState.questions, action.payload];

      break;

    case CLONE_QUESTION: {
      const { id } = action.payload;

      const questionIndex = newState.questions.findIndex((question) => question.id === id);

      const clonedQuestion = { ...newState.questions[questionIndex] };
      clonedQuestion.id = new Date().getTime();
      clonedQuestion.order = clonedQuestion?.order + 1;
      clonedQuestion.name = `question${clonedQuestion.order + 1}`;
      clonedQuestion.title = `COPY OF - ${clonedQuestion.title}`;
      clonedQuestion.isActive = true;

      const newQuestions = [
        ...newState.questions.slice(0, questionIndex + 1), // Questions before original
        clonedQuestion,
        ...newState.questions.slice(questionIndex + 1) // Questions after original
      ];

      const mappedQuestions = newQuestions.map((question, index) => {
        if (question.id === clonedQuestion.id) {
          return { ...question, name: `question${index + 1}`, isActive: true, order: index + 1 };
        } else {
          return { ...question, name: `question${index + 1}`, isActive: false, order: index + 1 };
        }
      });

      return {
        ...newState,
        questions: mappedQuestions
      };
    }

    case REMOVE_QUESTION:
      if (newState.questions.length > 1) {
        newState.questions = newState.questions.filter((question) => question.id !== action.payload.id);
      }
      newState.questions = newState.questions.map((question, index) => {
        return { ...question, order: index + 1, name: `question${index + 1}` };
      });
      break;

    case REMOVE_FORM_ERRORS:
      newState.error = {};
      newState.questions = newState.questions.map((question) => {
        return { ...question, isActive: false };
      });

      newState.questions = newState.questions.map((question) => {
        question.options = question.options.map((option) => {
          return { ...option, error: {} };
        });
        return { ...question, error: {} };
      });
      break;

    case UPDATE_QUESTION:
      const index = newState.questions.findIndex((question) => question.id === action.payload.id);

      newState.questions[index] = {
        ...newState.questions[index],
        ...action.payload
      };
      break;

    case UPDATE_TEMPLATE:
      newState = { ...newState, ...action.payload };
      break;

    case DUPLICATE_LAST_QUESTION: {
      const sortedQuestions = [...newState.questions].sort((a, b) => a.order - b.order);

      if (newState.questions.length > 0) {
        const lastQuestionIndex = sortedQuestions.length - 1;
        const lastQuestion = sortedQuestions[lastQuestionIndex];
        const newQuestion = {
          ...lastQuestion,
          order: lastQuestion?.order + 1,
          name: `question${lastQuestion.order + 1}`,
          title: `Copy of - ${lastQuestion.title}`,
          isActive: true
        };
        newQuestion.id = new Date().getTime();
        newState.questions.push(newQuestion);
      }

      break;
    }

    case SET_ACTIVE_QUESTION:
      newState.questions = newState.questions.map((question) => {
        return { ...question, isActive: false };
      });

      const activeIndex = newState.questions.findIndex((question) => question.id === action.payload.id);

      newState.questions[activeIndex] = {
        ...newState.questions[activeIndex],
        isActive: true
      };

      break;

    case SET_QUESTION_OPTION_ERRORS: {
      const options = action.payload?.options || [];
      const questionId = action.payload?.questionId;

      const questionIndex = newState.questions.findIndex((question) => question.id === questionId);

      newState.questions = newState.questions.map((question) => {
        if (question.id === questionId) {
          return { ...question, isActive: true };
        }
        return { ...question, isActive: false };
      });

      newState.questions[questionIndex].options = newState.questions[questionIndex].options.map((option) => {
        const foundOption = options.find((opt) => opt.id === option.id);
        if (foundOption) {
          return { ...option, error: foundOption?.error };
        }
        return { ...option, error: {} };
      });
      break;
    }

    case ADD_QUESTION_OPTION:
      const questionIndex = newState.questions.findIndex(
        (question) => question.id === action.payload.questionId
      );

      newState.questions[questionIndex].options = [
        ...newState.questions[questionIndex].options,
        action.payload.option
      ];

      break;

    case REMOVE_QUESTION_OPTION:
      const removeQuestionIndex = newState.questions.findIndex(
        (question) => question.id === action.payload.questionId
      );

      const questionToModify = newState.questions[removeQuestionIndex];

      questionToModify.options = questionToModify.options.filter(
        (option) => option.id !== action.payload.optionId
      );

      break;

    case UPDATE_QUESTION_OPTION:
      const updateQuestionIndex = newState.questions.findIndex(
        (question) => question.id === action.payload.questionId
      );

      const questionToUpdate = newState.questions[updateQuestionIndex];

      questionToUpdate.options = questionToUpdate.options.map((option) => {
        if (option.id === action.payload.optionId) {
          return { ...option, ...action.payload.option };
        }
        return option;
      });

      break;

    case SWITCH_QUESTION_ORDER: {
      const { id, move = 'up' } = action.payload;
      const sortedQuestions = [...newState.questions].sort((a, b) => a.order - b.order);
      const qIndex = sortedQuestions.findIndex((question) => question.id === id);

      const newQuestions = sortedQuestions.map((question, index) => {
        if (move === 'up') {
          if (index === qIndex - 1) {
            return { ...question, order: question.order + 1 };
          }
          if (index === qIndex) {
            return { ...question, order: question.order - 1 };
          }
        } else {
          if (index === qIndex) {
            return { ...question, order: question.order + 1 };
          }

          if (index === qIndex + 1) {
            return { ...question, order: question.order - 1 };
          }
        }

        return question;
      });

      const mappedQuestions = newQuestions
        .sort((a, b) => a.order - b.order)
        .map((question, index) => {
          return { ...question, order: index + 1, name: `question${index + 1}` };
        });

      newState.questions = [...mappedQuestions];

      break;
    }

    case REORDER_QUESTION_OPTIONS: {
      const { questionId, options } = action.payload;
      return {
        ...state,
        questions: state?.questions?.map((q) => (q?.id === questionId ? { ...q, options } : q))
      };
    }

    default:
      break;
  }

  return newState;
};

export default templateGeneratorReducer;
